import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import SplashScreenWrapper from './components/SplashScreenWrapper';

ReactDOM.render(
  <React.StrictMode>
    <SplashScreenWrapper 
      appName="VB6 Designer"
      version="0.1.0"
      minDisplayDuration={2000}
    >
      <App />
    </SplashScreenWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
